<template>
  <v-card>
    <v-card-title>
      <div class="headline">{{data.quoteInfo.product}}</div>
    </v-card-title>
    <v-card-text>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.proposalNo}}</v-subheader>
          <div class="title">{{data.quoteInfo.proposalNo}}</div>
        </v-flex>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.paid}}</v-subheader>
          <div class="title">{{checkPaid(data.quoteInfo.paid)}}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.tripType}}</v-subheader>
          <div class="title">{{formatTripType(data.quoteInfo.tripType)}}</div>
        </v-flex>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.travelType}}</v-subheader>
          <div class="title">{{formatTravelType(data.quoteInfo.travelType)}}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.selectedPlan}}</v-subheader>
          <div class="title">{{data.quoteInfo.plan}}</div>
        </v-flex>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.areaCovered}}</v-subheader>
          <div class="title">{{data.quoteInfo.area}}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.noAdult}}</v-subheader>
          <div class="title">{{data.quoteInfo.noAdult}}</div>
        </v-flex>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.noChildren}}</v-subheader>
          <div class="title">{{data.quoteInfo.noChild}}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.comDate}}</v-subheader>
          <div class="title">{{formatDisplayDate(data.quoteInfo.startDate)}}</div>
        </v-flex>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.expDate}}</v-subheader>
          <div class="title">{{formatDisplayDate(data.quoteInfo.endDate)}}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.premiumPaid}}</v-subheader>
          <div class="title">{{formatDisplayNumber(data.quoteInfo.premium)}}</div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { tripType, travelType } from '@/const/underwriting/travel'
import { globalMixin } from './globalMixin'

export default {
  data() {
    return {
      labels: {
        proposalNo: 'Proposal No.',
        status: 'Status',
        tripType: 'Trip Type',
        selectedPlan: 'Selected Plan',
        noAdult: 'No. of Adult(s)',
        comDate: 'Commencement Date',
        premiumPaid: 'Premium Paid',
        travelType: 'Travel Type',
        areaCovered: 'Area Covered',
        noChildren: 'No. of Child(ren)',
        expDate: 'Expired Date'
      }
    }
  },
  methods: {
    formatTripType(t) {
      return tripType[t]
    },
    formatTravelType(t) {
      return travelType[t]
    },
    checkPaid(value) {
      if (value) {
        return 'Paid'
      } else {
        return 'Unpaid'
      }
    }
  },
  computed: {
    data() {
      return this.$store.state.adminMember.member.trans
    }
  },
  mixins: [globalMixin]
}
</script>

<style>
</style>
